import {workOptions} from "../Assets/StaticContents/HowItWorksContent";
import vector_img from "../Assets/img/illustrastions/vector-2.png";
import React from "react";

const HowItWorks = ({appType, setAppType}) => {

    const filterWorkOptions = workOptions.filter(n => n.isDriver === appType)
    const listWorkOptions = filterWorkOptions.map((option, key) =>{
        return (
            <div key={key} className="relative bg-white flex-col flex lg:w-1/3">
                <div data-aos="fade-up" data-aos-delay={200 * key} className="px-2 md:px-4 py-4">
                    <img src={option.image} alt="App Process" loading="lazy" className="max-w-full h-auto mx-auto" />
                    <div className="pt-4 md:pt-8 lg:pt-12 max-w-xs mx-auto">
                        <div className="flex justify-center" dangerouslySetInnerHTML={{ __html: option.svg}}>
                        </div>
                        <div className="flex justify-center py-4">
                            <h3 className="text-lg font-semibold text-gray-700">{option.title}</h3>
                        </div>
                        <div className="text-center">
                            <p>{option.text}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    })

    const headingForCarOwner = `Making money with your empty car seats on Parizzo Carpool is as simple as 1,2,3 ...`
    const headingForPassenger = `Joining a ride on Parizzo Carpool is as simple as 1,2,3...`
    return (
        <section className="px-2 sm:px-4 md:px-10 lg:px-16 py-16 relative">
            <img src={vector_img} alt="Vector" className="top-0 left-0 hidden md:block absolute opacity-80" />
            <div className="w-full md:max-w-lg lg:max-w-3xl mx-auto text-center py-4 space-y-5 relative z-10">
                <h2 data-aos="fade-up" className="text-lg sm:text-2xl font-semibold uppercase">
                    How Parizzo Carpool App Works
                </h2>
                <div data-aos="fade-up" className="text-md text-gray-700 w-full max-w-xl mx-auto text-center">
                    { appType ? headingForCarOwner : headingForPassenger}
                </div>

                <div data-aos="fade-up" className="max-w-xs mx-auto py-4 w-full">
                    <div className="bg-gray-200 p-0.5 flex items-center rounded-md">
                        <button
                            onClick={ () => setAppType(false) }
                            className={`${!appType ? 'bg-green-app text-white' : 'bg-transparent text-gray-500'} py-2.5 w-full  rounded-md focus:outline-none`}>
                            <span className="text-center">Passenger</span>
                        </button>
                        <button
                            onClick={ () => setAppType(true) }
                            className={`${appType ? 'bg-green-app text-white' : 'bg-transparent text-gray-500'} py-2.5 w-full  rounded-md focus:outline-none`}>
                            <span className="text-center">Car Owner</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="lg:px-2">
                <div className="mt-8 flex flex-wrap w-full items-start">
                    { listWorkOptions }
                </div>
            </div>
        </section>
    )
}

export default HowItWorks